// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useSyncExternalStore } from "react";

let _unreadCount = 0;
const _listeners = new Set<() => void>();

function notifyListeners() {
  for (const listener of _listeners) listener();
}

export function setUnreadCount(count: number): void {
  if (count === _unreadCount) return;
  _unreadCount = count;
  notifyListeners();
}

export function useUnreadNotificationCount(): number {
  return useSyncExternalStore(
    (cb) => {
      _listeners.add(cb);
      return () => _listeners.delete(cb);
    },
    () => _unreadCount,
  );
}
